import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useEffect, useRef, useState } from 'react';
import { Animated, Dimensions, Easing, Text, View, Platform, PanResponder } from 'react-native';
import { Popup } from '../../Popup/rn';
import { RichTextInWebView } from '../../RichText/rn/RichTextInWebView';
import { FONT_WEIGHT_MEDIUM } from '../../../styles/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { checkHaveTable } from '../../../utils/tools';
import { debounce } from '../../../utils/lodashReplacement';
import { richTextTouchEndDebounceTime } from '../../../utils/constants';
export var PopupArticle = function PopupArticle(props) {
  var zIndex = props.zIndex,
    active = props.active,
    title = props.title,
    content = props.content,
    closeButtonText = props.closeButtonText,
    onClose = props.onClose,
    changeTrackCloseArticleContentData = props.changeTrackCloseArticleContentData,
    articleContentTrackingData = props.articleContentTrackingData,
    disableSpecialLink = props.disableSpecialLink,
    showExpandIcon = props.showExpandIcon,
    webViewKey = props.webViewKey,
    accordionOptions = props.accordionOptions,
    isUIOptimisationTable = props.isUIOptimisationTable,
    haveMinRichTextWidth = props.haveMinRichTextWidth;
  var scrollViewRef = useRef(null);
  var scrollY = useRef(new Animated.Value(0)).current;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    titleHeight = _useState2[0],
    setTitleHeight = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    accordionOffsetTop = _useState4[0],
    setAccordionOffsetTop = _useState4[1];
  var isUIOptimisationTableStyle = isUIOptimisationTable && checkHaveTable(content);
  var PopupArticlePaddingHorizontal = isUIOptimisationTableStyle ? 0 : 24;
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    scrollEnabled = _useState6[0],
    setScrollEnabled = _useState6[1]; // const handleDisabledScroll = debounce(
  //   () => {
  //     setScrollEnabled(false);
  //   },
  //   100,
  //   { leading: true }
  // );

  var handleDisabledScroll = function handleDisabledScroll() {
    setScrollEnabled(false);
  };
  var handleRichTextTouchEnd = debounce(function () {
    setScrollEnabled(true);
  }, richTextTouchEndDebounceTime);
  var panResponder = useRef(PanResponder.create({
    // 处理开始滑动事件
    onStartShouldSetPanResponder: function onStartShouldSetPanResponder() {
      return true;
    },
    // 处理滑动事件
    onMoveShouldSetPanResponder: function onMoveShouldSetPanResponder(_, gestureState) {
      // 判断滑动方向是否为横向
      var isHorizontalSwipe = Math.abs(gestureState.dx) > Math.abs(gestureState.dy); // 如果是横向滑动，则禁止父级ScrollView的垂直滚动

      if (isHorizontalSwipe) {
        handleDisabledScroll();
        return true;
      } else {
        return false;
      }
    }
  })).current;
  var getPopupContentStyle = function getPopupContentStyle() {
    var _Dimensions$get = Dimensions.get('window'),
      height = _Dimensions$get.height;
    var NAVIGATION_BAR_HEIGHT = Platform.OS === 'ios' ? 44 : height >= 800 ? 56 : 48;
    return {
      paddingBottom: NAVIGATION_BAR_HEIGHT || 0
    };
  };
  useEffect(function () {
    scrollY === null || scrollY === void 0 ? void 0 : scrollY.addListener(function (animation) {
      var _scrollViewRef$curren;
      (_scrollViewRef$curren = scrollViewRef.current) === null || _scrollViewRef$curren === void 0 ? void 0 : _scrollViewRef$curren.scrollTo({
        y: animation.value,
        animated: true
      });
    });
    return function () {
      return scrollY.removeAllListeners();
    };
  }, []);
  useEffect(function () {
    var needScrollToAccordion = (accordionOptions === null || accordionOptions === void 0 ? void 0 : accordionOptions.isUIOptimisationAccordion) && (accordionOptions === null || accordionOptions === void 0 ? void 0 : accordionOptions.accordionIndex) !== undefined && (accordionOptions === null || accordionOptions === void 0 ? void 0 : accordionOptions.accordionIndex) > -1;
    if (active && needScrollToAccordion && accordionOffsetTop > 0) {
      setTimeout(function () {
        Animated.timing(scrollY, {
          toValue: titleHeight + accordionOffsetTop,
          duration: 0,
          easing: Easing.cubic,
          useNativeDriver: true
        }).start();
      }, 300);
    } else {
      var _scrollViewRef$curren2;
      scrollY.setValue(0);
      (_scrollViewRef$curren2 = scrollViewRef.current) === null || _scrollViewRef$curren2 === void 0 ? void 0 : _scrollViewRef$curren2.scrollTo({
        y: 0,
        animated: true
      });
    }
  }, [active, accordionOptions, accordionOffsetTop]);
  return /*#__PURE__*/React.createElement(Popup, {
    showCloseIcon: true,
    zIndex: zIndex,
    closeButtonText: closeButtonText,
    active: active,
    title: "Article",
    onClose: onClose,
    titleStyle: styles['modal-article-title'],
    contentScrollable: false,
    contentStyle: _objectSpread(_objectSpread({
      flex: undefined
    }, getPopupContentStyle()), isUIOptimisationTableStyle ? styles["article-popup-content-container-ui-optimisation-table-modal"] : {})
  }, /*#__PURE__*/React.createElement(Animated.ScrollView, _extends({
    ref: scrollViewRef,
    showsVerticalScrollIndicator: false,
    scrollEventThrottle: 16,
    onScrollBeginDrag: function onScrollBeginDrag() {
      return scrollY.stopAnimation();
    },
    overScrollMode: "never",
    scrollEnabled: Platform.OS === 'android' ? scrollEnabled : true
  }, panResponder.panHandlers), /*#__PURE__*/React.createElement(View, {
    onStartShouldSetResponder: function onStartShouldSetResponder() {
      return true;
    }
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles['content-article-title'], isUIOptimisationTableStyle && styles['content-article-title-ui-optimisation-table-modal']],
    onLayout: function onLayout(event) {
      var height = event.nativeEvent.layout.height;
      var _styles$contentArtic = styles['content-article-title'],
        marginTop = _styles$contentArtic.marginTop,
        marginBottom = _styles$contentArtic.marginBottom;
      setTitleHeight(height + marginTop + marginBottom);
    }
  }, title), /*#__PURE__*/React.createElement(RichTextInWebView, {
    webViewKey: webViewKey,
    onClose: onClose,
    content: content,
    changeTrackCloseArticleContentData: changeTrackCloseArticleContentData,
    articleContentTrackingData: articleContentTrackingData,
    disableSpecialLink: !!disableSpecialLink,
    showExpandIcon: showExpandIcon,
    defaultWidth: Dimensions.get('window').width - PopupArticlePaddingHorizontal,
    onImageError: props.onImageError,
    onImageLoad: props.onImageLoad,
    accordionOptions: _objectSpread(_objectSpread({}, accordionOptions), {}, {
      onAccordionOffsetTopChange: function onAccordionOffsetTopChange(offsetTop) {
        setAccordionOffsetTop(offsetTop);
      }
    }),
    isUIOptimisationTableModal: isUIOptimisationTable,
    haveMinRichTextWidth: haveMinRichTextWidth,
    handleDisabledScroll: handleDisabledScroll,
    richTextTouchEnd: handleRichTextTouchEnd
  }))));
};
var styles = CustomStyleSheet({
  'modal-article-title': {
    textAlign: 'center'
  },
  'content-article-title': _objectSpread(_objectSpread({}, FONT_WEIGHT_MEDIUM), {}, {
    fontSize: 16,
    lineHeight: 20,
    color: 'rgba(0, 0, 0, 0.87)',
    marginTop: 4,
    marginBottom: 16,
    overflow: 'hidden'
  }),
  'article-popup-content-container-ui-optimisation-table-modal': {
    paddingHorizontal: 0
  },
  'content-article-title-ui-optimisation-table-modal': {
    paddingHorizontal: 12
  }
});